import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {LoginPayload, LoginResponse} from "./login.entity";
import {login} from "./login.api";
import {AppDispatch} from "@/lib/store.ts";
import {fetchUser} from "@/lib/store/auth.slice.ts";
import {fetchOrganizations} from "@/lib/store/organization.slice.ts";

interface LoginState {
    email: string;
    password: string;
    loading: boolean;
    error: string | null;
}

const initialState: LoginState = {
    email: "",
    password: "",
    loading: false,
    error: null,
};

export const loginUser = createAsyncThunk<
    LoginResponse,
    LoginPayload,
    { dispatch: AppDispatch }
>("login/loginUser", async (payload, { dispatch }) => {
    const res = await login(payload);
    await dispatch(fetchUser());
    await dispatch(fetchOrganizations());
    return res;
});

const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        setEmail(state, action: PayloadAction<string>) {
            state.email = action.payload;
        },
        setPassword(state, action: PayloadAction<string>) {
            state.password = action.payload;
        },
        clearLoginState(state) {
            state.email = "";
            state.password = "";
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(loginUser.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Login failed";
            });
    },
});

export const { setEmail, setPassword, clearLoginState } = loginSlice.actions;
export default loginSlice.reducer;